export function isValidDate(date: Date | unknown): boolean {
    return date instanceof Date && !isNaN(date.getTime())
}

export function parseDate(date: string): Date {
    const [yyyy, mm, dd] = date.split('-')
    return new Date(`${yyyy}-${mm}-${dd}`)
}

export function parseDateTime(date: string): Date {
    return new Date(date)
}
